import { StepType } from '@reactour/tour';

const common = [
  {
    selector: '[className=cloud_accounts]',
    content:
      'This shows the cloud environment that the Dashboard is summarizing',
  },
  {
    selector: '[className=identity_type]',
    content: 'Choose which identity type you need insights for',
  },
  {
    selector: '[className=identity_name]',
    content:
      'Get a quick summary of your user identity by hovering on the username',
  },
  {
    selector: '[className=review_alerts_with_click]',
    content: 'Review all alerts for a user with a single click',
  },
  {
    selector: '[className=identity_excess_roles]',
    content: 'See all excess roles, policies and permissions for a user',
  },
  {
    selector: '[className=identity_user_graph]',
    content: 'Switch to a visual graph for a 360  view of a user',
  },
];

export const visibilityIdentityUserTourSteps: StepType[] = [
  ...common,
  {
    selector: '[className=identity_policies]',
    content: 'Review all user policies (attached or inline)',
  },
  {
    selector: '[className=cross_account_access]',
    content:
      'Identify roles that have cross-account access. These can create indirect, hidden paths of\n' +
      'attack for external or 3rd party accounts',
  },
];

export const visibilityIdentityResourceTourSteps: StepType[] = [
  ...common,
  {
    selector: '[className=identity_insights_activity]',
    content: 'Review all policies associated with non-user identities',
  },
];
